import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

orderHistorySearchTagsStyles.appliedFilterTag = {
    css: css`
        background: ${getColor("primary")};
        border: 1px solid ${getColor("primary")};
        border-radius: unset;
        span[class^="TypographyStyle"] {
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: ${getColor("primary.contrast")};
        }
        :hover {
            background: ${getColor("text.accent")};
        }
        > button {
            :hover {
                background: transparent;
            }
            background: transparent;
            span[class^="IconWrapper"] {
                > svg {
                    color: ${getColor("primary.contrast")};
                }
            }
        }
    `,
};
